
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns5a7204273248763cd73f239bd631761een from './en.yaml'
            i18n.addResourceBundle('en', '5a7204273248763cd73f239bd631761e', flattenObject(ns5a7204273248763cd73f239bd631761een), true, true);
        
        export default '5a7204273248763cd73f239bd631761e';
    